import { useSelector } from "react-redux";
import { rolesDependencies } from "./dependencies";
import { hasOneOfRoles } from "./selectors";
import useRoles from "./useRoles";

export default function useRolesRestrictions(requiredRoles) {
	const { roles } = useRoles();
	const userRoles = roles.filter((value) => value === true);
	const openForRoles = requiredRoles?.getOpenForRoles();
	const openForRelevantRoles = filterRolesOnParentRole(openForRoles);

	const hasRequiredToOpenRoles = useSelector((state) =>
		hasOneOfRoles(state, openForRelevantRoles),
	);

	const restrictOnRoles =
		!hasRequiredToOpenRoles && openForRelevantRoles.length > 0
			? openForRelevantRoles
			: [];

	function filterRolesOnParentRole(requiredRoles) {
		if (!requiredRoles) {
			return [];
		}

		const roleDependenciesEntries = Object.entries(rolesDependencies);
		const requiredRolesAreParentRoles = requiredRoles.every((role) => rolesDependencies[role]);
		const requiredRolesHaveDependencies = requiredRoles.some((role) => roleDependenciesEntries.flat(2).includes(role));

		if (requiredRoles.length <= 1 || requiredRolesAreParentRoles || !requiredRolesHaveDependencies) {
			return requiredRoles;
		}

		return requiredRoles.filter((role) => {
			let parentRole;

			for (const [key, value] of roleDependenciesEntries) {
				if (value.includes(role)) {
					parentRole = key;
				}
			}

			return userRoles.has(parentRole);
		});
	}

	return {
		hasRequiredToOpenRoles,
		restrictOnRoles,
	};
}
